export enum DeviceOrientation {
    portrait = 'Portrait',
    landscape = 'Landscape',
}

const moreMediaQuery = (minWidth: number, orientation?: DeviceOrientation): string => {
    if (orientation === DeviceOrientation.landscape) {
        return `@media screen and (min-width: ${minWidth}px) and (orientation: landscape)`;
    }

    if (orientation === DeviceOrientation.portrait) {
        return `@media screen and (min-width: ${minWidth}px) and (orientation: portrait)`;
    }

    return `@media screen and (min-width: ${minWidth}px)`;
}

const lessMediaQuery = (maxWidth: number, orientation?: DeviceOrientation): string => {
    if (orientation === DeviceOrientation.landscape) {
        return `@media screen and (max-width: ${maxWidth - 1}px) and (orientation: landscape)`;
    }

    if (orientation === DeviceOrientation.portrait) {
        return `@media screen and (max-width: ${maxWidth - 1}px) and (orientation: portrait)`;
    }

    return `@media screen and (max-width: ${maxWidth - 1}px)`;
}


export const device = {
    more1180: moreMediaQuery(1180),
    less1400: lessMediaQuery(1400),
    less1180: lessMediaQuery(1180),
    less768: lessMediaQuery(768),
}
